import React, { useContext, useEffect, useState } from 'react';
import Details from './Details/Details';
import AllDevices from './AllDevices/AllDevices';
import classes from './DataHub.module.css';
import { Form, Formik } from 'formik';
import { toast } from 'react-toastify';
import { get as LodashGet } from 'lodash';
import ExportModal from './Details/ExportModal';
import { START_LOADER, STOP_LOADER } from '../../../../constants';
import { DataHubServiceRoot } from '../../../../services/DataHubService';
import { Input, TextArea, ToggleButtonWithState } from '../../../../components/Inputs/Input';
import TabsComponent from '../../../../components/Tabs/Tabs';
import ModalComponent from '../../../../components/ModalComponent/ModalComponent';
import Typography from '../../../../components/Typography/Typography';
import Dropdown from '../../../../components/Inputs/Dropdown';
import { LoaderContext } from '../../../../context/LoaderContext';
import { sortByName } from '../../../../utils/objectHelper';
import { AddDataHubKeyValidation, DataHubValidation } from '../../../../validations/DataHub/DataHub';
import { UilSetting } from '@iconscout/react-unicons';
import { signalsServiceForRoot } from '../../../../services/signalsServiceForRoot';

const DataHub = ({ updateQueryParams, queryParamsData }) => {
    const [initialValues, setInitialValues] = useState({});
    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });
    const [refresh, setRefresh] = useState({});
    const [open, setOpen] = useState(false);
    const [addKeyModal, setAddKeyModal] = useState(queryParamsData.addKeyModal || false);
    const [groups, setGroups] = useState([]);
    const [device, setDevice] = useState({});
    const [editDevice, setEditDevice] = useState({});
    const [processedDevices, setProcessedDevices] = useState([]);
    const [priceDropdown, setPriceDropdown] = useState([]);
    const [showExportModal, setShowExportModal] = useState(queryParamsData.showExportModal || false);
    const [selectedIndex, setSelectedIndex] = useState(queryParamsData.subTab || 0);

    useEffect(() => {
        readAllData();
    }, [refresh]);

    useEffect(() => {
        readPowerCost();
    }, []);

    useEffect(() => {
        updateQueryParams('addKeyModal', addKeyModal);
    }, [addKeyModal]);

    useEffect(() => {
        updateQueryParams('showExportModal', showExportModal);
    }, [showExportModal]);

    useEffect(() => {
        updateQueryParams('subTab', selectedIndex);
    }, [selectedIndex]);

    const readPowerCost = () => {
        signalsServiceForRoot.ReadAllByType(
            'Power Cost',
            () => startLoader('Power Cost'),
            handleReadPowerCostSuccess,
            handleError,
            () => stopLoader('Power Cost')
        );
    };

    const handleReadPowerCostSuccess = ({ data }) => {
        if (data?.data?.length) {
            const options = [{ label: 'None', value: '' }];
            data.data.forEach((item) => options.push({ label: item.name, value: item._id }));
            setPriceDropdown(options);
        }
    };

    const readAllData = () => {
        DataHubServiceRoot.readAll(
            () => startLoader('readAll'),
            handleReadAllSuccess,
            handleError,
            () => stopLoader('readAll')
        );
    };

    const handleOpen = (device, groupId) => {
        if (groupId) {
            device.groupId = groupId;
        }
        if (device?.dataHub) {
            setInitialValues({
                ...device.dataHub,
            });
        } else {
            setInitialValues({
                ...device,
            });
        }

        setDevice(device);
        setOpen(true);
    };

    const handleReadAllSuccess = ({ data }) => {
        const allMeters = data.data;
        const processedData = allMeters.map((meter) => {
            return {
                name: meter.key || '--',
                _id: meter?._id,
                devices: meter.meterIdData.map((data) => {
                    const name = LodashGet(data, 'dataHub.name') || data.id;
                    const priceSignal = LodashGet(data, 'dataHub.priceSignal');
                    const taxValue = LodashGet(data, 'dataHub.taxValue');
                    return {
                        ...data.dataHub,
                        name: name,
                        id: data.id,
                        groupId: meter._id,
                        priceSignal: data.dataHub.priceSignal,
                        taxValue: data.dataHub.taxValue,
                        cvr: meter.key,
                        actions: (
                            <div className={classes.ActionContainer}>
                                <div>
                                    <UilSetting style={{ color: 'var(--color-primary)' }} size={'1.2vw'} onClick={() => handleOpen(data, meter._id)} />
                                </div>
                                <div className={classes.ToggleContainer}>
                                    <ToggleButtonWithState
                                        disabled={!Boolean(priceSignal && !(taxValue === null || taxValue === undefined))}
                                        value={data.dataHub.enabled}
                                        onChange={(e) => handleToggleChange(data, meter._id, e.target.checked)}
                                    />
                                </div>
                            </div>
                        ),
                    };
                }),
            };
        });
        setGroups(processedData);
        const processedDevices = processedData.map((group) => group.devices).flat();
        setProcessedDevices(processedDevices);
    };

    const handleToggleChange = (device, groupId, value) => {
        device.groupId = groupId;
        DataHubServiceRoot.updateStatus(
            device.groupId,
            device.id,
            { dataHub: { ...device.dataHub, enabled: value } },
            () => startLoader('updateStatus'),
            handleUpdateStatusSuccess,
            handleError,
            () => stopLoader('updateStatus')
        );
    };

    const handleUpdateStatusSuccess = ({ data }) => {
        toast.success('Configuration Updated!');
        readAllData();
    };

    const handleUpdateDataHub = (values) => {
        DataHubServiceRoot.updateDevice(
            device.groupId,
            device.id,
            { dataHub: values },
            () => startLoader('updateMeter'),
            handleUpdateSuccess,
            handleError,
            () => stopLoader('updateMeter')
        );
    };

    const handleUpdateSuccess = ({ data }) => {
        setDevice({});
        setInitialValues({});
        readAllData();

        toast.success('Configuration Updated!');
        setOpen(false);
    };

    const handleAddKey = (val) => {
        DataHubServiceRoot.addKey(
            val,
            () => startLoader('addKey'),
            handleAddKeySuccess,
            handleError,
            () => stopLoader('addKey')
        );
    };

    const handleAddKeySuccess = ({ data }) => {
        toast.success('Key added successfully!');
        setAddKeyModal(false);
        readAllData();
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    let tabs = [
        {
            name: 'Details',
            component: (
                <Details
                    setEditDevice={setEditDevice}
                    handleOpen={handleOpen}
                    setRefresh={setRefresh}
                    startLoader={startLoader}
                    stopLoader={stopLoader}
                    processedDevices={processedDevices}
                    groups={sortByName(groups)}
                    queryParamsData={queryParamsData}
                    updateQueryParams={updateQueryParams}
                />
            ),
        },
        {
            name: 'All Meters',
            component: <AllDevices processedDevices={processedDevices} groups={groups} addKeyModal={addKeyModal} setAddKeyModal={setAddKeyModal} />,
        },
    ];

    return (
        <div className={'ventilation'}>
            <TabsComponent tabs={tabs} setShowExportModal={setShowExportModal} selectedIndex={selectedIndex} onChangeTab={setSelectedIndex} />
            <ExportModal isOpen={showExportModal} setOpen={setShowExportModal} groups={groups} />

            <ModalComponent isOpen={open} setOpen={setOpen}>
                <div className={classes.AddKey}>
                    <Typography content={initialValues?.groupId ? 'Edit Config' : 'Add Config'} />
                    <Formik enableReinitialize validationSchema={DataHubValidation} initialValues={initialValues} onSubmit={(val) => handleUpdateDataHub(val)}>
                        {({ errors, touched, values, isValidating, ...props }) => (
                            <Form>
                                <div className={classes.InputContainer}>
                                    <div className={classes.FieldControl}>
                                        <label for="name">Enter Name of MeterId</label>
                                        <Input name="name" id="name" />
                                    </div>
                                    <div className={classes.FieldControl}>
                                        <label for="group">Price Signal</label>
                                        <Dropdown
                                            name="priceSignal"
                                            options={priceDropdown}
                                            defaultValue={priceDropdown.filter((signal) => signal.value === initialValues.priceSignal)[0]}
                                        />
                                    </div>
                                    <div className={classes.FieldControl}>
                                        <label for="taxValue">Tax Value (Kr/mwh)</label>
                                        <Input name="taxValue" id="taxValue" />
                                    </div>
                                    <div className={classes.FieldControl}>
                                        <label for="address">Address</label>
                                        <TextArea name="address" id="address" />
                                    </div>
                                </div>
                                <div className={classes.ButtonContainer}>
                                    <div>
                                        <div className="btn-secondary" onClick={() => setOpen(false)}>
                                            Cancel
                                        </div>
                                    </div>
                                    <div>
                                        <button type="submit" className="btn-primary">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </ModalComponent>
            <ModalComponent isOpen={addKeyModal} setOpen={setAddKeyModal}>
                <div className={classes.AddKey}>
                    <Typography content="Add Key" />
                    <Formik enableReinitialize initialValues={{ key: '' }} onSubmit={(val) => handleAddKey(val)} validationSchema={AddDataHubKeyValidation}>
                        {({ errors, touched, values, isValidating, ...props }) => (
                            <Form>
                                <div className={classes.InputContainer}>
                                    <div className={classes.FieldControl}>
                                        <label for="key">
                                            Enter new key to add (CVR)
                                            <span className="required">*</span>
                                        </label>
                                        <Input name="key" id="key" />
                                    </div>
                                </div>
                                <div className={classes.ButtonContainer}>
                                    <div>
                                        <div className="btn-secondary" onClick={() => setAddKeyModal(false)}>
                                            Cancel
                                        </div>
                                    </div>
                                    <div>
                                        <button type="submit" className="btn-primary">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </ModalComponent>
        </div>
    );
};

export default DataHub;
